const trimEmptyValuesFromObject = function trimEmptyValuesFromObject(obj) {
  const filteredObject = Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== '' && value !== undefined && value !== null));
  return filteredObject;
};
export default trimEmptyValuesFromObject;